import { useState } from 'react'

import { useFetch } from '@reveni-io/reveni-ui'

import returnsServices from '@/returns/services/services'

const useImportCreateRmas = ({ storeId, setToastInfo }) => {
  const [showImportCreateRmasDrawer, setShowImportCreateRmasDrawer] = useState(false)
  const [importFile, setImportFile] = useState(null)
  const [importError, setImportError] = useState('')
  const [showImportInProgressModal, setShowImportInProgressModal] = useState(false)
  const { fetchData: importData, loading: importing } = useFetch(returnsServices.importRmasCreation, {
    doInitialRequest: false,
  })

  const openImportCreateRmasDrawer = () => {
    setShowImportCreateRmasDrawer(true)
  }

  const closeImportCreateRmasDrawer = () => {
    setShowImportCreateRmasDrawer(false)
    setImportError('')
    setImportFile(null)
  }

  const onSelectImportFile = files => {
    setImportFile(files?.[0] || null)
  }

  const onDeleteImportFile = fileName => {
    if (importFile?.name === fileName) {
      setImportFile(null)
    }
  }

  const onCloseImportInProgressModal = () => {
    setShowImportInProgressModal(false)
  }

  const onImportCreateRmasFile = async () => {
    try {
      const formData = new FormData()
      formData.append('file', importFile)
      await importData({ storeId, formData })
      closeImportCreateRmasDrawer()
      setShowImportInProgressModal(true)
    } catch (error) {
      setToastInfo({ show: true, message: error.errorMessage, type: 'error' })
    }
  }

  return {
    openImportCreateRmasDrawer,
    closeImportCreateRmasDrawer,
    showImportCreateRmasDrawer,
    onSelectImportFile,
    onDeleteImportFile,
    importFile,
    setImportFile,
    importError,
    setImportError,
    onImportCreateRmasFile,
    importing,
    showImportInProgressModal,
    onCloseImportInProgressModal,
  }
}

export default useImportCreateRmas
